import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountryDto } from 'src/app/data-transfer/entities/country-dto';
import { CompanyDto } from 'src/app/data-transfer/entities/doc-entities/company-dto';
import { DialogActions } from 'src/app/model/dictionary';

export class PpwrProducerDialogData {
  constructor(
    public readonly title: string,
    public readonly icon: string,
    public readonly countries: CountryDto[] = [],
    public readonly producer?: CompanyDto
  ) {}

  get isEditMode(): boolean {
    return !!this.producer;
  }
}

@Component({
  selector: 'app-ppwr-producer-dialog',
  templateUrl: './ppwr-producer-dialog.component.html',
  styleUrls: ['./ppwr-producer-dialog.component.scss'],
})
export class PpwrProducerDialogComponent {
  form: FormGroup;
  title: string;
  icon: string;
  countries: CountryDto[] = [];
  isEditMode = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: PpwrProducerDialogData,
    private dialogRef: MatDialogRef<PpwrProducerDialogComponent>,
    private formBuilder: FormBuilder
  ) {
    this.title = dialogData.title;
    this.icon = dialogData.icon;
    this.countries = dialogData.countries ?? [];
    this.isEditMode = dialogData.isEditMode;

    this.form = this.formBuilder.group({
      companyName: [dialogData.producer?.companyName ?? '', Validators.required],
      address: [dialogData.producer?.address ?? '', Validators.required],
      postCode: [dialogData.producer?.postCode ?? '', Validators.required],
      city: [dialogData.producer?.city ?? '', Validators.required],
      location: [dialogData.producer?.location ?? '', Validators.required],
    });
  }

  doAction(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    this.dialogRef.close({
      event: DialogActions.CONFIRM,
      data: this.form.value,
    });
  }

  closeDialog(): void {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
